"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowUpRight } from "react-icons/pi";

export default function PortfolioGrid({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const projects = content.projects || [
    { title: "E-Commerce App", category: "Mobile Development", link: "#", imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop" },
    { title: "Branding Agency", category: "Visual Identity", link: "#", imageUrl: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=600&fit=crop" },
    { title: "Crypto Dashboard", category: "Web Design", link: "#", imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop" }
  ];

  return (
    <section
      className={`py-24 px-6 bg-white text-slate-900 transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-left space-y-4 max-w-xl">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
            <EditableText
              value={content.title || "Selected Work"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((proj: any, idx: number) => (
            <div key={idx} className="space-y-4 group">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-slate-100 border border-slate-100 shadow-sm relative">
                <img src={proj.imageUrl} alt={proj.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <a
                  href={proj.link}
                  className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-white flex items-center justify-center text-slate-900 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <PiArrowUpRight className="w-4 h-4" />
                </a>
              </div>
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-lg font-bold text-slate-900">{proj.title}</h3>
                  <p className="text-slate-500 text-sm">{proj.category}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
